import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { instrumentationSchema } from './instrumentation-schema';
import { startActivity } from './util';

const GoalCreationEditorUnstyled = (props) => {
  const {
    goalData,
    permissions,
    serverContext,
    scope,
    perfMarker,
    instrumentation,
    isDemo,
    getGoalCreationRecommendationWizard,
    exportUpdatedGoalObject,
  } = props;

  useMemo(() => instrumentation.addScenario(instrumentationSchema), [instrumentation]);
  const { logScenario } = useMemo(() => {
    const scenario = instrumentation.goalCreationRecommendationWizard.create();
    const logInfo = {
      logScenario: scenario,
      logActivity: scenario.createGoalCreationRecommendationWizard.create(),
    };
    startActivity(logInfo.logActivity);
    return logInfo;
  }, [instrumentation.goalCreationRecommendationWizard]);

  const wizardDefaultState = {
    currentStep: 'editGoalDetails.normalGoal',
    goalObject: goalData,
    isEditScenario: true,
    logScenario,
  };

  const GoalCreationRecommendationWizard = getGoalCreationRecommendationWizard;

  const goalCreationWizard = (<GoalCreationRecommendationWizard
    permissions={permissions}
    serverContext={serverContext}
    scope={scope}
    perfMarker={perfMarker}
    goalData={goalData}
    wizardDefaultState={wizardDefaultState}
    isDemo={isDemo}
    exportUpdatedGoalObject={exportUpdatedGoalObject}
  />);

  return (
    !_.isEmpty(wizardDefaultState)) && (
    goalCreationWizard
  );
};

GoalCreationEditorUnstyled.propTypes = {
  permissions: PropTypes.shape({}).isRequired,
  serverContext: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    values: PropTypes.shape({}),
  }).isRequired,
  perfMarker: PropTypes.shape({}).isRequired,
  getGoalCreationRecommendationWizard: PropTypes.objectOf(PropTypes.any).isRequired,
  exportUpdatedGoalObject: PropTypes.func.isRequired,
};

export const GoalCreationEditor = withInstrumentation(GoalCreationEditorUnstyled);
